import type { ImportMetaEnv } from "../../../types.env.d.ts";

export const getApiUrl = (): ImportMetaEnv["VITE_API_BASE_URL"] => {
  return import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080";
};
